import { create } from 'zustand';

/**
 * Store для управления download polling и SSE таймаутом
 * Хранит функции для обоих режимов скачивания:
 * - startPolling: для polling режима (recovery mode)
 * - startDownloadTimeout: для SSE режима (таймаут ожидания события)
 * И флаг isInRecoveryMode для определения нужно ли использовать polling
 * - triggerImmediatePoll: для немедленного запуска пулинга после пользовательских действий
 */
export interface DownloadPollingStore {
  startPolling: (() => void) | null;
  startDownloadTimeout: (() => void) | null;
  isInRecoveryMode: boolean;
  triggerImmediatePoll: (() => void) | null;
  setStartPolling: (fn: (() => void) | null) => void;
  setStartDownloadTimeout: (fn: (() => void) | null) => void;
  setIsInRecoveryMode: (isInRecovery: boolean) => void;
  setTriggerImmediatePoll: (fn: (() => void) | null) => void;
  clearStartPolling: () => void;
}

export const useDownloadPollingStore = create<DownloadPollingStore>((set) => ({
  startPolling: null,
  startDownloadTimeout: null,
  isInRecoveryMode: false,
  triggerImmediatePoll: null,

  setStartPolling: (fn) => {
    set({ startPolling: fn });
  },

  setStartDownloadTimeout: (fn) => {
    console.log('📦 [DownloadPollingStore] setStartDownloadTimeout called', { hasFn: !!fn });
    set({ startDownloadTimeout: fn });
  },

  setIsInRecoveryMode: (isInRecovery) => {
    set({ isInRecoveryMode: isInRecovery });
  },

  setTriggerImmediatePoll: (fn) => {
    console.log('📦 [DownloadPollingStore] setTriggerImmediatePoll called', { hasFn: !!fn });
    set({ triggerImmediatePoll: fn });
  },

  clearStartPolling: () => {
    set({
      startPolling: null,
      startDownloadTimeout: null,
      isInRecoveryMode: false,
      triggerImmediatePoll: null,
    });
  },
}));
